import StoreLayout from "../../components/store-layout"

const Store = ({type = ""}) => {
 
  return (
    <>
      <StoreLayout type={type} />
    </>
  );
}

export default Store;
